export const SET_RECAPTCHA = 'recaptcha/SET_RECAPTCHA';
export const POST_RECAPTCHA = 'saga/recaptcha/POST_RECAPTCHA';
